import { Policy } from './policy';
import { PolicyTypeIconConstants } from './policy-type-icon-constants';
import { UnderlyingPolicy } from './underlying-policy';

export class UmbrellaPolicy extends Policy {
  public underlyingPolicies: UnderlyingPolicy[] = [];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(json: any) {
    super(json);
    this.iconType = PolicyTypeIconConstants.UMBRELLA;
    this.policyType = 'umbrella';

    this.policyRisks = [this.policyDescription];
    this.riskDescriptionList = [this.policyDescription];

    for (const policy of json.underlyingPolicies) {
      this.underlyingPolicies.push(new UnderlyingPolicy(policy));
    }
  }
}
